import * as jsxRuntime from "/builds/storage360/seek-and-store/admin-interface/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment